"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;

var React = __importStar(require("react"));

var core_1 = require("@emotion/core");

var utils_1 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

exports.Avatar = utils_1.forwardRef(function Avatar(props, ref) {
  var src = props.src,
      alt = props.alt,
      title = props.title,
      fallbackAction = props.fallbackAction,
      stacked = props.stacked,
      index = props.index,
      _a = props.total,
      total = _a === void 0 ? 10 : _a,
      rest = __rest(props, ["src", "alt", "title", "fallbackAction", "stacked", "index", "total"]);

  var className = rest.className || '';

  var _b = React.useState(false),
      error = _b[0],
      setError = _b[1];

  React.useEffect(function () {
    if (error && fallbackAction) {
      fallbackAction();
    }
  }, [error]);
  var avatar = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\theight: 2em;\n\t\twidth: 2em;\n\t\tborder-radius: 2em;\n\t\tbackground: url(", ");\n\t\tbackground-color: ", ";\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: cover;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-transform: uppercase;\n\t\tfont-size: 14px;\n\t\tfont-weight: 800;\n\t\tcolor: ", ";\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t\ttransition: all 0.3s ease-in-out;\n\t\tz-index: ", ";\n\t\t", ";\n\t\t", ";\n\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t\ttransition: all 0.3s ease-in-out;\n\t\t}\n\t"], ["\n\t\theight: 2em;\n\t\twidth: 2em;\n\t\tborder-radius: 2em;\n\t\tbackground: url(", ");\n\t\tbackground-color: ", ";\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: cover;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-transform: uppercase;\n\t\tfont-size: 14px;\n\t\tfont-weight: 800;\n\t\tcolor: ", ";\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t\ttransition: all 0.3s ease-in-out;\n\t\tz-index: ", ";\n\t\t", ";\n\t\t", ";\n\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t\ttransition: all 0.3s ease-in-out;\n\t\t}\n\t"])), src, foundation_1.colors.primary.red, foundation_1.colors.white, index === 0 || index ? total - index : 0, stacked && "box-shadow: 0 0 0 2px white;", index && index > 0 && "margin-left: -3px;", foundation_1.colors.primary.darkRed);
  var hidden = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\theight: 1px;\n\t\twidth: 1px;\n\t\tvisibility: hidden;\n\t\tposition: absolute;\n\t\tz-index: -10;\n\t"], ["\n\t\theight: 1px;\n\t\twidth: 1px;\n\t\tvisibility: hidden;\n\t\tposition: absolute;\n\t\tz-index: -10;\n\t"])));
  return (0, _core.jsx)(lseds_1.lseds.div, {
    css: avatar
  }, (!src || error) && title && title.charAt(0), src && !error && (0, _core.jsx)("img", {
    src: src,
    alt: alt,
    css: hidden,
    onError: function onError() {
      return setError(true);
    },
    className: className
  }));
});
var templateObject_1, templateObject_2;